import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import GetCarrierDisplayName from '../../components/data-driven-logo/get-carrier-display-name';
import messages from './messages';
import moment from 'moment-timezone';

const Events = {
  FULFILLMENT_PLAN_MOVE_ITEM_EVENT: 'FulfillmentPlanMoveItemEvent',
  GENERIC_UPDATE: 'GenericUpdate',
  LABEL_CREATE_EVENT: 'LabelCreateEvent',
  RESTORED_FROM_HOLD: 'RestoredFromHold',
  SET_ON_HOLD: 'SetOnHold',
};

const DisplayMessages = {
  LabelCreateEvent: (attributes) => {
    const carrierName = GetCarrierDisplayName(attributes.CarrierId);
    const displayValues = {
      ...attributes,
      carrierName,
    };
    return <FormattedMessage {...messages.LabelCreateEvent} values={displayValues} />;
  },
  SetOnHold: (attributes) => {
    const holdUntil = moment(attributes.HoldUntilUtc).tz(attributes.sellerTimeZone).format(attributes.userDateTimeFormat);
    const displayValues = {
      ...attributes,
      holdUntil,
    };
    return <FormattedMessage {...messages.SetOnHold} values={displayValues} />;
  },
  GenericUpdate: (attributes) => {
    const previousCount = attributes['previous:ItemCount'];
    const newCount = attributes['new:ItemCount'];
    const displayValues = {
      ...attributes,
      previousCount,
      newCount,
    };
    return <FormattedMessage {...messages.GenericUpdate} values={displayValues} />;
  },
};

const MessageDisaplay = ({ event = '', attributes }) => {
  if (event === Events.LABEL_CREATE_EVENT) {
    return DisplayMessages.LabelCreateEvent(attributes);
  }
  if (event === Events.RESTORED_FROM_HOLD) {
    return <FormattedMessage {...messages.RestoredFromHold} values={attributes} />;
  }
  if (event === Events.SET_ON_HOLD) {
    return DisplayMessages.SetOnHold(attributes);
  }
  if (event === Events.GENERIC_UPDATE) {
    return DisplayMessages.GenericUpdate(attributes);
  }
  if (event === Events.FULFILLMENT_PLAN_MOVE_ITEM_EVENT) {
    return <FormattedMessage {...messages.FulfillmentPlanMoveItemEvent} values={attributes} />;
  }
  // Not displaying any message for activity events not covered in current implementation
  return null;
};

MessageDisaplay.propTypes = {
  event: PropTypes.string,
  attributes: PropTypes.object.isRequired,
};

export default MessageDisaplay;
